// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled

import { start as ujsStart } from "@rails/ujs";
import { start as turubolinkStart } from "turbolinks";
import { start as activeStorageStart } from "@rails/activestorage";
import channels from "channels";

import jQuery from "jquery";
import "bootstrap";
import "../stylesheets/application";
import "core-js/stable";
import "@coreui/coreui";
import "@coreui/chartjs";
import "@coreui/utils";
import "@fortawesome/fontawesome-free/js/all";
import toastr from "toastr";

import "./customer/customer";
import "./customer/localities";
import "./user/profile";
import "./utils/clock";
import "./utils/dashboard_chart";
import "./utils/inventory_pdf";

window.toastr = toastr;
require("chart.js");

require("trix");
require("@rails/actiontext");

import "./get_localities";

/*import { Sidebar, Alert, Popover } from "@coreui/coreui";*/

$(document).ready(function () {
  $('[data-toggle="tooltip"]').tooltip();
});

const images = require.context("../images", true);
const imagePath = (name) => images(name, true);
